import React, { Component } from "react";
import AdminApi from "../utils/AdminApi";
import { Button, Dimmer, Loader, Icon } from "semantic-ui-react";

class ImportFromQuill extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      finished: false,
      old_finished: false,
      num_new_apps: 0,
      num_old_apps: 0,
      new_rounds: [],
    };
    this.handleClick = this.handleClick.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  handleClick() {
    this.setState({
      loading: true,
    });
    AdminApi.loadAppsFromQuill()
      .then((response) => {
        console.log(response);
        this.setState({
          finished: true,
          num_new_apps: response.data.num_new_apps,
          new_rounds: response.data.new_rounds,
        });
      })
      .catch((error) => {
        alert(error);
        this.setState({
          loading: false,
        });
      });
  }

  handleFeatherClick = () => {
    this.setState({
      loading: true,
    });

    AdminApi.loadAppsFromFeather()
      .then((response) => {
        console.log("response here", response);
        this.setState({
          finished: true,
          num_new_apps: response.data.num_new_apps,
        });
      })
      .catch((error) => {
        alert(error);
        this.setState({
          loading: false,
        });
      });
  };

  handleLoadNewApps = () => {
    this.setState({
      new_loading: true,
    });

    AdminApi.loadNewAppsFromFeather()
      .then((response) => {
        console.log("response here", response);
        this.setState({
          finished: true,
          num_new_apps: response.data.num_new_apps,
        });
      })
      .catch((error) => {
        alert(error);
        this.setState({
          loading: false,
        });
      });
  };

  handleRemoveOldApps = () => {
    this.setState({
      old_loading: true,
    });

    AdminApi.removeOldAppsFromFeather()
      .then((response) => {
        console.log("response here", response);
        this.setState({
          old_finished: true,
          num_old_apps: response.data.num_old_apps,
        });
      })
      .catch((error) => {
        alert(error);
        this.setState({
          loading: false,
        });
      });
  };

  handleNormalizeClick = () => {
    this.setState({
      normalizeLoading: true,
    });

    AdminApi.loadNormalizeRound().then((response) => {
      console.log("normalized", response);
    });
  };

  onClose() {
    window.location.reload();
  }

  render() {
    let loader = (
      <Loader
        className={this.state.loading ? "active" : ""}
        inline="centered"
        inverted
      >
        <br />
      </Loader>
    );
    let newloader = (
      <Loader
        className={this.state.new_loading ? "active" : ""}
        inline="centered"
        inverted
      >
        <br />
      </Loader>
    );
    let oldloader = (
      <Loader
        className={this.state.old_loading ? "active" : ""}
        inline="centered"
        inverted
      >
        <br />
      </Loader>
    )
    let finished = (
      <Dimmer active={this.state.finished} onClickOutside={this.onClose} page>
        <h2>
          <Icon name="check" /> Loaded {this.state.num_new_apps} new applicants!
          Refresh page and start grading!
        </h2>
      </Dimmer>
    );
    let old_finished = (
      <Dimmer active={this.state.old_finished} onClickOutside={this.onClose} page>
        <h2>
          <Icon name="check" /> Removed {this.state.num_old_apps} old applicants!
          Refresh page and start grading!
        </h2>
      </Dimmer>
    );
    return (
      <div>
        {finished}
        {old_finished}
        {/* <Button
          color="blue"
          size="large"
          onClick={this.handleClick}
          style={{ marginBottom: "10px" }}
        >
          {loader}Import from Quill
        </Button> */}
        <Button color="red" size="large" onClick={this.handleFeatherClick}>
          {loader}Import From Plume
        </Button>
        <Button color="orange" size="large" onClick={this.handleLoadNewApps}>
          {newloader}Load New Apps
        </Button>
        <Button color="green" size="large" onClick={this.handleRemoveOldApps}>
          {oldloader}Fix Load Apps
        </Button>
        {/* <Button
          color="orange"
          size="large"
          content="Normalize"
          onClick={this.handleNormalizeClick}
        /> */}
      </div>
    );
  }
}

export default ImportFromQuill;



// WEBPACK FOOTER //
// ./src/components/admin/ImportFromQuill.js